import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProjectCreationComponent } from '../project-creation/project-creation.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectService } from '../../api/services/project.services';
import { Project, PaginatedProjectDTO, ProjectUserInput } from '../../api/models/project-model';
import { AuthService } from '../../api/services/auth.service';
import { ProjectOrderStatus } from '../../api/models/project-order-status';
import { MarketBannerService } from '../market-banner/market-banner.service';
import { Subscription } from 'rxjs/Subscription';
import { PaginatedRequest } from '../../api/models/paginated-request';
import { Subject } from 'rxjs/Subject';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { ProjectHealth, ProjectHealthInput } from '../../api/models/project-health';
import { PreferencesService } from '../../api/services/preferences.service';
import { Worksheet } from '../../api/models/worksheet';
import { Router } from '@angular/router';
import { OrderCreateComponent } from '../order-create/order-create.component';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-dashboard-my-oasis',
  templateUrl: './dashboard-my-oasis.component.html',
  styleUrls: ['./dashboard-my-oasis.component.scss']
})
export class DashboardMyOasisComponent implements OnInit, OnDestroy {

  specialSelected: string = "#";
  currentMarket: string;
  defaultIcon = '&#xe' + (2306).toString(16);
  marketSelected = true;
  myProjects: boolean = false;
  projects: Project[] = [];
  page = 1;
  pageSize = 20;
  currentStatus = 'All';
  sorting: string = "";
  sortingItems = {
    deliveryDate: {
      initted: false,
      toggle: false
    },
    name: {
      initted: false,
      toggle: false
    }
  };
  projectStatus: boolean;
  projectSearchText: string;
  projectStatusString: string;
  searchSubject: Subject<string> = new Subject<string>();
  paginatedRequest: PaginatedRequest;
  projectUserInput: ProjectUserInput;
  marketSubscription : Subscription;
  projectOrderStatus: ProjectOrderStatus[];
  projectList: PaginatedProjectDTO;
  totalRecords = 0;
  canViewPricing: boolean;
  loading: boolean;
  noProjectText = [];
  canViewAvailability = false;
  projectListFlag = false;
  roleRequest: RoleRequest
  projectHealthMap: {[key: string]: ProjectHealth};
  createProjectButtonName: string;
  selectedProjectIds: string[] = [];
  selectedProjectNames = [];
  isTesscoAdmin: boolean = false;
  isClientAdmin: boolean = false;
  kindFilterSelected: 'Active' | 'Inactive' = 'Active';

  orderError = false;
  err: string[] = [];

  constructor(private modalService: NgbModal,
    private projectService: ProjectService,
    private authService: AuthService,
    private marketBannerService: MarketBannerService,
    private preferencesService: PreferencesService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {
    this.searchSubject.asObservable()
      .debounceTime(1000)
      .subscribe(projectSearchText => {
        if (projectSearchText) {
          this.projectSearchText = projectSearchText;
        }
        this.loadPage(1);
      });
   }

  loadPage(page) {
    this.projectHealthMap = undefined;
    if (this.kindFilterSelected === 'Active') {
      this.projectStatus = true;
    } else {
      this.projectStatus = false;
    }
    this.projectStatusString = this.kindFilterSelected;
    this.paginatedRequest = new PaginatedRequest(page, this.pageSize, this.sorting);
    this.projectUserInput = new ProjectUserInput(this.authService.getUserId(), this.projectStatus, this.projectStatusString, this.projectSearchText);
    this.projectService.getMyProjects(this.currentMarket, this.projectUserInput, this.paginatedRequest).subscribe(paginatedProjectDTO => {
      this.projectList = paginatedProjectDTO;
      if (this.projectList.totalRecords && this.projectList.totalRecords > 0) {
        this.projectListFlag = true;
        this.totalRecords = this.projectList.totalRecords;
        this.projects = this.projectList.records;
        this.selectedProjectIds = [];
        this.selectedProjectNames = [];
        let projectHealthInput: ProjectHealthInput[] = [];
        this.projects.forEach(project => {
          projectHealthInput.push(new ProjectHealthInput(project.id, project.name, this.projectListFlag));
          project.isSelected = false;
        });
        this.projectService.getProjectHealthByMarket(this.currentMarket, projectHealthInput).subscribe(projectHealths => {
          let phs = projectHealths;
          if (phs && phs.length) {
            this.projectHealthMap = {};
            phs.forEach(ph => this.projectHealthMap[ph.id] = ph);
          }
        });
        if (this.specialSelected !== 'ATC'){
          this.preferencesService.getPreferencesByIds('PROJECT', 'oracle-project-number', this.projects.map(p => p.id)).subscribe(prefs => {
            prefs && this.projects.forEach(p => {
              if(prefs[p.id]){
                p.projectNumber = prefs[p.id].Value;
              }
            });
          });
        }
        this.setLoading(false);
      } else {
        this.projects = [];
        this.totalRecords = 0;
        this.selectedProjectIds = [];
        this.selectedProjectNames = [];
        this.setLoading(false);
        this.setNoProjectText();
      }
    }, error => {
      this.projects = [];
      this.totalRecords = 0;
      this.selectedProjectIds = [];
      this.selectedProjectNames = [];
      this.setLoading(false);
      this.setNoProjectText();
    });
  }

  filter() {
    this.myProjects = !this.myProjects;
    this.page = 1;
    this.loadPage(this.page);
  }

  toggle(name) {
    if (!this.sortingItems[`${name}`].innited
          || (this.sortingItems[`${name}`].innited && this.sortingItems[`${name}`].toggle)) {
      this.sortingItems[`${name}`].innited = true;
      this.sortingItems[`${name}`].toggle = !this.sortingItems[`${name}`].toggle;
      this.falsySortingItems(name);
      this.sort(name);
    } else if (this.sortingItems[`${name}`].innited && !this.sortingItems[`${name}`].toggle) {
      this.sortingItems[`${name}`].innited = false;
      this.sortingItems[`${name}`].toggle = false;
      this.page = 1;
      this.sorting = "";
      this.loadPage(this.page);
    }
  }

  falsySortingItems(name) {
    Object.keys(this.sortingItems).forEach(k => {
      if (k !== name) {
        this.sortingItems[k].innited = false;
        this.sortingItems[k].toggle = false;
      }
    });
  }

  sort(name) {
    this.page = 1;

    if (!name) { return; }

    if (this.sortingItems[`${name}`].toggle) {
      this.sorting = name + ',asc';
    } else {
      this.sorting = name + ',desc';
    }

    this.loadPage(this.page);
  }

  searchProjects(value) {
    this.page = 1;
    if (value) {
      this.projectSearchText = value;
      this.searchSubject.next(value);
    } else {
      this.projectSearchText = "";
      this.loadPage(this.page);
    }
  }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    this.searchProjects(pastedText);
  }

  createWorksheet(project: Project) {
    if (project) {
      let worksheet = new Worksheet();
      worksheet.projectId = project.id;
      worksheet.siteName = project.name
      worksheet.siteNumber = '0000';
      worksheet.requestedDeliveryDate = project.deliveryDate;
      worksheet.contractorId = null;
      worksheet.confirmedNeedByDate = false;

      let addressSelectedId = null;
      this.preferencesService.getPreferences('PROJECT', project.id).subscribe(projectPrefs => {
        addressSelectedId = projectPrefs['site-address'].Value;
        if (!addressSelectedId) {
          this.preferencesService.getPreferences('MARKET', project.marketId).subscribe(marketPrefs => {
            addressSelectedId = marketPrefs['default-address'].Value;
          });
        }
      });

      if(addressSelectedId){
        worksheet.shipToAddressId = addressSelectedId;
        worksheet.confirmedShipToAddressId = true;
      } else {
        worksheet.shipToAddressId = null;
        worksheet.confirmedShipToAddressId = false;
      }

      const modalRef = this.modalService.open(OrderCreateComponent, {
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });    
      modalRef.componentInstance.project = project;
      modalRef.componentInstance.worksheet = worksheet;
      modalRef.componentInstance.action = 'Create';

      this.loadPage(1);
    }
  }

  onErrorAction(error: any) {
    this.orderError = true;
    this.err.push(error.error.message);
  }

  clearError() {
    this.orderError = false;
    this.err = [];
  }

  createProject() {
    const modalRef = this.modalService.open(ProjectCreationComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.project = new Project();
    modalRef.componentInstance.specialSelected = this.specialSelected;
    modalRef.componentInstance.action = 'New';

    modalRef.result.then((result) => {
      if (this.specialSelected !== 'ATC' && result) {
          this.createWorksheet(result);
      } else {
        this.loadPage(1);
      }
    }).catch(() => { 
      //Empty catch block
    });
  }

  format(string: string) {
    return string[0].toUpperCase().concat(string.substr(1));
  }
  ngOnInit() {
    this.setLoading(true);
    this.marketBannerService.setMarketBanner();
    this.marketSubscription = this.marketBannerService.getMarketBanner()
      .subscribe(market => {
        if (market) {
          this.currentMarket = market.id;
          if (this.currentMarket) {
            this.preferencesService.getPreferences('CUSTOMER', market.customerId).subscribe(prefs => {
              this.specialSelected = prefs['special-fields'].Value;
              if (this.specialSelected !== 'ATC'){
                this.setLoading(false);
                this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['market-order-summary', this.currentMarket] } }]);
              } else{
                this.createProjectButtonName = 'Create Project';
              }
            });

            this.roleRequest = new RoleRequest('AVAILABILITY_VIEW', null);
            this.roleRequest.setRoleAndContextMap('PRICING_VIEW', null);
            this.roleRequest.setRoleAndContextMap('ADMIN_TESSCO', null);
            this.roleRequest.setRoleAndContextMap('ADMIN_CLIENT', null);
            this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
              this.canViewAvailability = roles.getRoleMap('AVAILABILITY_VIEW');
              this.canViewPricing = roles.getRoleMap('PRICING_VIEW');
              this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
              this.isClientAdmin = roles.getRoleMap('ADMIN_CLIENT');
              this.loadPage(1);
            });
          } else {
            this.marketSelected = false;
            this.setLoading(false);
            this.setNoProjectText();
          }
        } else {
          this.marketSelected = false;
          this.setLoading(false);
          this.setNoProjectText();
        }
    }, error => {
      this.marketSelected = false;
      this.setLoading(false);
      this.setNoProjectText();
    });
  }

  preventRedirect(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  selectItem(item: Project) {
    this.projects.find(project => project.id === item.id).isSelected = !item.isSelected;
    if (item.isSelected) {
      this.selectedProjectIds.push(item.id);
      this.selectedProjectNames.push(item);
    } else {
      this.selectedProjectIds = this.selectedProjectIds.filter(id => id !== item.id);
      this.selectedProjectNames = this.selectedProjectNames.filter(project => project.id !== item.id);
    }
  }

  deleteProject(item: Project) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.headerMsg = "Confirmation!";
    modalRef.componentInstance.bodyMsg = `Are you sure you want to mark <strong>${item.name}</strong> as inactive?`;
    modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
    modalRef.componentInstance.fn = () => {
      this.projectService.deleteProject(item.id).subscribe(() => {
        modalRef.close();
        modalRef.result.then(() => {
          this.onDeleteSuccess("Project " + item.name + " marked inactive");
          this.loadPage(this.page);
        }).catch();
      },error => {
        modalRef.close();
        this.onDeleteError("Error while making project " + item.name + " as inactive");
      });
    };
  }

  activeProject(item: Project) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.headerMsg = "Confirmation!";
    modalRef.componentInstance.bodyMsg = `Are you sure you want to mark <strong>${item.name}</strong> as active?`;
    modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
    modalRef.componentInstance.fn = () => {
      this.projectService.activeProject(item.id).subscribe(() => {
        modalRef.close();
        modalRef.result.then(() => {
          this.onDeleteSuccess("Project " + item.name + " marked active");
          this.loadPage(this.page);
        }).catch();
      },error => {
        modalRef.close();
        this.onDeleteError("Error while making project " + item.name + " as active");
      });
    };
  }

  bulkProjectInactive() {
    if (this.selectedProjectIds.length > 0) {
      const modalRef = this.modalService.open(ConfirmationModalComponent, {
        backdrop: 'static',
        keyboard: false
      });
      let projectNames = "";
      this.selectedProjectNames.forEach((selectedProjectName, index) => {
        projectNames = projectNames.concat(`${selectedProjectName.name}`);
        (index + 1) !== this.selectedProjectNames.length ?
        projectNames = projectNames.concat(', ') : projectNames = projectNames.concat('');
      });
      modalRef.componentInstance.headerMsg = "Confirmation!";
      modalRef.componentInstance.bodyMsg = `Are you sure you want to mark <strong>${projectNames}</strong> as inactive?`;
      modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
      modalRef.componentInstance.fn = () => {
        this.projectUserInput = new ProjectUserInput(this.authService.getUserId(), false, this.kindFilterSelected, undefined, this.selectedProjectIds);
        this.projectService.bulkUpdateProjectStatus(this.projectUserInput).subscribe(() => {
          modalRef.close();
          modalRef.result.then(() => {
            this.onDeleteSuccess("Selected projects marked inactive");
            this.selectedProjectIds = [];
            this.selectedProjectNames = [];
            this.loadPage(1);
          }).catch();
        },error => {
          modalRef.close();
          this.onDeleteError("Error while making selected projects as inactive");
        });
      };
    } else {
      this.onDeleteError("Please select projects from the list.");
    }
  }

  bulkProjectActive() {
    if (this.selectedProjectIds.length > 0) {
      const modalRef = this.modalService.open(ConfirmationModalComponent, {
        backdrop: 'static',
        keyboard: false
      });
      let projectNames = "";
      this.selectedProjectNames.forEach((selectedProjectName, index) => {
        projectNames = projectNames.concat(`${selectedProjectName.name}`);
        (index + 1) !== this.selectedProjectNames.length ?
        projectNames = projectNames.concat(', ') : projectNames = projectNames.concat('');
      });
      modalRef.componentInstance.headerMsg = "Confirmation!";
      modalRef.componentInstance.bodyMsg = `Are you sure you want to mark <strong>${projectNames}</strong> as active?`;
      modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
      modalRef.componentInstance.fn = () => {
        this.projectUserInput = new ProjectUserInput(this.authService.getUserId(), true, this.kindFilterSelected, undefined, this.selectedProjectIds);
        this.projectService.bulkUpdateProjectStatus(this.projectUserInput).subscribe(() => {
          modalRef.close();
          modalRef.result.then(() => {
            this.onDeleteSuccess("Selected projects marked active");
            this.selectedProjectIds = [];
            this.selectedProjectNames = [];
            this.loadPage(1);
          }).catch();
        },error => {
          modalRef.close();
          this.onDeleteError("Error while making selected projects as active");
        });
      };
    } else {
      this.onDeleteError("Please select projects from the list.");
    }
  }

  private onDeleteSuccess(msg: string) {
    this.toastr.success(msg, 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onDeleteError(msg: string) {
    this.toastr.error(msg, 'Fail!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  selectAll() {
    this.selectedProjectIds = [];
    this.selectedProjectNames = [];
    this.projects.forEach(project => {
      project.isSelected = true;
      this.selectedProjectIds.push(project.id);
      this.selectedProjectNames.push(project);
    });
  }

  deselectAll() {
    this.selectedProjectIds = [];
    this.selectedProjectNames = [];
    this.projects.forEach(project => {
      project.isSelected = false;
    });
  }

  filterByKind(kind: 'Active' | 'Inactive' ) {
    this.selectedProjectIds = [];
    this.selectedProjectNames = [];
    this.kindFilterSelected = kind;
    this.page = 1;
    this.loadPage(this.page);
  }

  getLoading() {
    return this.loading;
  }

  setLoading(value: boolean) {
    this.loading = value;
  }

  setNoProjectText() {
    if (this.kindFilterSelected === 'Active') {
      this.noProjectText = ["No Active Project to show"];
    } else {
      this.noProjectText = ["No Inactive Project to show"];
    }
  }

  clearNoProjectText() {
    this.noProjectText = [];
  }

  ngOnDestroy(): void {
    this.marketSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/dashboard-my-oasis.component.ts